/* eslint-disable typescript-sort-keys/interface */
/* eslint-disable sort-destructure-keys/sort-destructure-keys */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable jsdoc/require-jsdoc */
/* eslint-disable @typescript-eslint/no-explicit-any */
import * as XLSX from 'xlsx'

export function exportDataToExcel({
  data,
  sheetName,
  fileName,
}: {
  data: any[]
  sheetName: string
  fileName: string
}) {
  // Create a worksheet from the data
  const ws = XLSX.utils.json_to_sheet(data)

  // Create a workbook with the worksheet
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)

  // Write the Excel file to a Blob and trigger download
  XLSX.writeFile(wb, `${fileName}.xlsx`)
}

export function importDataFromExcel({
  fileData,
  structure,
}: {
  fileData: string | ArrayBuffer | null | undefined
  structure?: string[]
}) {
  const wb = XLSX.read(fileData, { type: 'array' })

  // Assuming the first sheet in the workbook
  const ws = wb.Sheets[wb.SheetNames[0]]

  let jsonData = []
  let validStructure = true

  if (structure) {
    const cols: string[] = (XLSX.utils.sheet_to_json(ws, { header: 1 })[0] ??
      []) as string[]

    validStructure =
      cols.length === structure.length &&
      cols.every((column) => structure.includes(column))
  }

  jsonData = XLSX.utils.sheet_to_json(ws)

  return { jsonData, validStructure }
}

/**
 * Agrupa los registros por titular (T) y familiares (F) en grupos familiares
 * @param {Array} jsonData - Array de objetos importados desde Excel
 * @returns {Array} Array de grupos familiares: [{ titular, familiares: [] }]
 */
export function groupFamiliaresByTitular(jsonData: any[]) {
  const grupos = []
  let grupoActual: { titular: any; familiares: any[] } | null = null

  for (const row of jsonData) {
    if (row.tipo === 'T') {
      // Nuevo titular, inicia nuevo grupo
      grupoActual = {
        titular: row,
        familiares: [],
      }
      grupos.push(grupoActual)
    } else if (row.tipo === 'F' && grupoActual) {
      // Familiar, agregar al grupo actual
      (grupoActual.familiares as any[]).push(row)
    }
    // Si hay otros tipos, puedes extender la lógica aquí
  }
  return grupos
}
